<template>
  <fieldset>
      <legend>{{Language.say('settings.layout.font_size')}}</legend>
      <div class="control-group">
          <ul class="control radio-group font-size">
              <li
                v-for="(font, font_index) in font_sizes"
                :key="font_index">
                  <input type="radio"
                    :id="`font-size-${font_index}`"
                    name="radio"
                    :checked="layout_controller.storage.font_size == `font-size-${font}`"
                    tabindex="-1">
                  <label
                    @click="onSetFontSize(`font-size-${font}`)"
                    :for="`font-size-${font_index}`"
                    tabindex="0">
                      {{Language.say(`settings.layout.font_${font}`)}}
                  </label>
              </li>
          </ul>
      </div>
  </fieldset>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language from '@/js/Shared/Language/Language';

  const props = defineProps({
    layout_controller: Object
  })

  const font_sizes = ['small', 'default', 'large'];

  const onSetFontSize = (size) => {
    props.layout_controller.font_size = size;
  }
</script>